/*
  * Address component specific for Adalia M&E.
  * This is a composite based on other components.
  */
import React from 'react';

import Base from './base.jsx'; 
import {
    Mode,
    DataType,
    castDataType
} from '../common.jsx';
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";

export default class AdaliaMEMapRegion extends Base {
    static get CATEGORY() {
        return 'question';
    }

    static get TYPE() {
        return 'adalia_me_map_region';
    }

    static get TRANSLATED_ATTRIBUTES() {
        return {
            label: 'field_default_label',
            description: 'field_default_description',
            help: null
        };
    }

    static icon() {
        return <i className="fa fa-map-o"></i>;
    }

    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            name: 'field_' + Helpers.randomString(),
            label: 'label',
            description: 'description',
            reportKey: '',
            required: false,
            label_hidden: false,
            lockEditWhenPrefilled: false,
            prettyView: {
                hide: false,
                show_label: false
            }
        });
    }

    constructor(props) {
        super(props);

        this.polygons = null;
    }

    renderView() {
        return (
            <div>
                <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                    <span className="field-label">{this.getText('label')}</span>
                    {this.props.content.required ? <span className='required-field'> *</span> : null}
                    {this.helpIcon()}
                    {this.renderPrefillIcon()}
                </label>
                <div ref="map" className="map"></div>
                <input ref="regions" type="hidden" name={this.fullFieldName()} defaultValue={this.getAnswer()} />
                {this.descriptionText()}
            </div>
        );
    }

    renderPrettyView() {
        const { hide = false, show_label = false } = this.props.content.prettyView || {};
        return (hide ? null :
            <div>
                {show_label &&
                    <label>
                        <span className="field-label">{this.getText('label')}</span>
                    </label>
                }
                <div ref="map" className="map"></div>
                <input ref="regions" type="hidden" name={this.fullFieldName()} defaultValue={this.getAnswer()} />
            </div>
        );
    }
    componentDidUpdate() {
        super.componentDidUpdate();

        if (this.props.mode == Mode.FILL) {
            if (this.getAnswerFromPolygons() != this.getAnswer()) {
                this.initMap();
            }
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.initMap();

        this.resize();
        jQuery(window).off('resize', this.resize).on('resize', this.resize);
    }

    initMap() {
        if (this.refs.regions) {
            this.polygons = JSON.parse(this.refs.regions.value || '[]').map(region => this.createPolygon(region))

            this.map = new google.maps.Map(this.refs.map, {
                mapTypeId: 'terrain'
            });

            // Center and zoom
            let bounds = new google.maps.LatLngBounds();

            if (this.polygons.length > 0) {
                this.polygons.forEach(p => p.getPath().getArray().forEach(coord => bounds.extend(coord)));
                this.map.setCenter(bounds.getCenter());
                this.map.fitBounds(bounds);
            } else {
                this.map.setCenter({ lat: 20, lng: 0 });
                this.map.setZoom(2);
            }

            // Draw polygons
            this.polygons.forEach(p => p.setMap(this.map));

            if (this.props.mode == Mode.FILL) {
                this.drawingManager = new google.maps.drawing.DrawingManager({
                    drawingMode: google.maps.drawing.OverlayType.POLYGON,
                    drawingControl: true,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.TOP_CENTER,
                        drawingModes: [
                            google.maps.drawing.OverlayType.POLYGON
                        ]
                    },
                    polygonOptions: this.polygonOptions()
                });
                this.drawingManager.setMap(this.map);

                this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.createClearButton());

                // Update answer when polygons change
                google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
                    this.addUpdateListeners([polygon]);
                    this.polygons.push(polygon);
                    this.updatePolygonsForAnswer();
                });
                this.addUpdateListeners(this.polygons);
            }
        }
    }

    addUpdateListeners = (polygons) => {
        polygons.forEach(polygon => ['set_at', 'insert_at', 'remove_at'].forEach(event => {
            google.maps.event.addListener(polygon.getPath(), event, this.updatePolygonsForAnswer);
        }));
    }

    getAnswerFromPolygons() {
        return this.polygons.length > 0
            ? JSON.stringify(this.polygons.map((p) => p.getPath().getArray()))
            : "";
    }

    updatePolygonsForAnswer = () => {
        this.updateAnswer(this.getAnswerFromPolygons());
    }

    renderSettings() {
        return (
            <div>
                <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
                <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
                <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
                <Setting.TextField
                  name="reportKey"
                  label={I18n.t('field_report_key', {scope: 'fe'})}
                  value={this.props.content.reportKey}
                  description={I18n.t('field_report_key_description', {scope: 'fe'})}
                  {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
                />
                <Setting.Checkbox name="lockEdit" label={I18n.t('field_lock_edit', {scope: 'fe'})} description={I18n.t('field_lock_edit_description', {scope: 'fe'})} value={this.props.content.lockEdit} onChange={this.updateSettings} />
                {AppConfig.features.form_prefill ? <Setting.Checkbox name="lockEditWhenPrefilled" label={I18n.t('field_lock_edit_when_prefilled', {scope: 'fe'})} description={I18n.t('field_lock_edit_when_prefilled_description', {scope: 'fe'})} value={this.props.content.lockEditWhenPrefilled} onChange={this.updateSettings} /> : null}
                {this.renderPrettyViewSettings()}
            </div>
        );
    }

    beforeUpdateSettings(content) {
        content.required = castDataType(content.required, DataType.BOOLEAN);
        content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
        content.lockEditWhenPrefilled = castDataType(content.lockEditWhenPrefilled, DataType.BOOLEAN);
        content.lockEdit = castDataType(content.lockEdit, DataType.BOOLEAN);
        this.beforeUpdateSettingsPrettyView(content);
    }

    resize = () => {
        const map = jQuery(this.refs.map);

        if (map.length > 0) {
            map.css('height', (map.width() / 2) + 'px');
        }
    }

    createPolygon(coords) {
        return new google.maps.Polygon(Object.assign({
            paths: coords
        }, this.polygonOptions()));
    }

    clearRegions = () => {
        this.polygons.forEach(p => p.setMap(null));
        this.polygons = [];
        this.updatePolygonsForAnswer();
    }

    polygonOptions() {
        return {
            strokeColor: '#F64D62',
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: '#F64D62',
            fillOpacity: 0.1,
            editable: this.props.mode == Mode.FILL,
            draggable: this.props.mode == Mode.FILL
        };
    }

    createClearButton() {
        const controlDiv = document.createElement('div');
        // Set CSS for the control border.
        const controlUI = document.createElement('div');
        controlUI.style.backgroundColor = '#fff';
        controlUI.style.border = '2px solid #fff';
        controlUI.style.borderRadius = '2px';
        controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
        controlUI.style.cursor = 'pointer';
        controlUI.style.textAlign = 'center';
        controlUI.style.margin = '5px';
        controlDiv.appendChild(controlUI);
        // Set CSS for the control interior.
        const controlText = document.createElement('div');
        controlText.style.color = 'rgb(25,25,25)';
        controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
        controlText.style.fontSize = '14px';
        controlText.style.padding = '2px 8px';
        controlText.innerHTML = '<i class="icon-trash text-danger" style="margin-right: 4px;"></i>' + I18n.t('adalia_me_map_region_clear', {scope: 'fe'});
        controlUI.appendChild(controlText);
        // Set listener
        controlUI.addEventListener('click', () => {
            if (confirm(I18n.t('adalia_me_map_region_clear_confirm', { scope: 'fe' }))) {
                this.clearRegions();
            }
        });
        return controlDiv;
    }

    getFormattedPrefillAnswer() {
        return I18n.t("x_regions", {
          scope: "fe",
          regions: JSON.parse(this.getPrefilledAnswer()).length,
        });
    }
}
